export default {
  methods: {
    tweakParamsForPlantsCall(params) {
      let parameters = Object.assign({}, params);

      if (this.sortBy) {
        // e.g. plant.name of ticket.created_at
        let shortSortBy = this.sortBy.split('.').reverse()[0];
        let sortOrder = this.sortOrder === 1 ? 'desc' : 'asc';
        parameters.sort = `${shortSortBy}:${sortOrder}`;
      }

      if (parameters.new_issues) {
        parameters.new_issues = parameters.new_issues
          .split(',')
          .map((s) => {
            const split = s.split('|');
            if (split[0] === 'shade') {
              return `shade_first_half|${split[1]},shade_second_half|${split[1]}`;
            } else {
              return s;
            }
          })
          .map((s) => {
            const split = s.split('|');
            if (split[0] === 'power_spike') {
              return `power_spike_medium|${split[1]},power_spike_high|${split[1]}`;
            } else {
              return s;
            }
          })
          .join(',');
      }
      return parameters;
    },
  },
};
